import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {getCommandsModalStatus, getDeviceTypes} from "../../../redux-store/selectors";
import {hideCommandsModal, sendCommand} from "../../../redux-store/map";
import {Controller, useForm} from "react-hook-form";
import {Select} from "antd";
import {REQUIRED_FIELD} from "../../../constants/Messages";
import ErrorIcon from "../../../images/errorIcon.png";

const {Option} = Select

const CommandsModal = ({installationId, devices}) => {
    const dispatch = useDispatch();
    const modalVisibility = useSelector(getCommandsModalStatus);
    const deviceTypes = useSelector(getDeviceTypes);

    const [commands, setCommands] = useState([]);

    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        control,
        watch
    } = useForm();

    const selectedDevice = watch("deviceId");
    useEffect(() => {
        if (!modalVisibility) reset({
            deviceId: null,
            methodName: null,
            arguments: null,
        })
    }, [modalVisibility]);
    useEffect(() => {
        if (devices.length === 0 || !modalVisibility) return;
        reset({
            deviceId: devices[0].id,
            methodName: null,
            arguments: null,
        })
        getCommandsSelectData(devices[0].id);
    }, [devices, modalVisibility]);

    useEffect(() => {
        if (selectedDevice === null) return;
        getCommandsSelectData(selectedDevice);
    }, [selectedDevice]);

    const onModalClose = () => {
        dispatch(hideCommandsModal());
    }
    const getCommandsSelectData = (deviceId) => {
        //find device
        const device = devices.find(item => item.id === deviceId);
        if (device === undefined) return;
        const deviceType = deviceTypes.find(item => item.model === device.model);
        if (deviceType === undefined) return;
        const {commandProducers} = deviceType;
        const commandsSelectData = [];
        commandProducers.forEach(item => {
            commandsSelectData.push({
                label: item,
                value: item,
            })
        })
        setCommands(commandsSelectData);
    }
    const onsubmit = (data) => {
        if (data.arguments)
            data.arguments = JSON.parse("[" + data.arguments + "]");
        else
            data.arguments = [];
        dispatch(sendCommand({installationId: installationId, data}));
    }

    return (
        <Modal
            show={modalVisibility}
            onHide={onModalClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component"}>
                <Modal.Title>Pošalji komandu</Modal.Title></Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(onsubmit)}>
                    <div className={"container"}>
                        <div className={"row mb-2"}>
                            <div className={"col-12"}>
                                <label className="mb-2 form-label" htmlFor="command">Uređај</label>
                                <Controller
                                    control={control}
                                    name={"deviceId"}
                                    render={({
                                                 field: {onChange, value, ref},
                                             }) => (<Select
                                        onChange={onChange}
                                        value={value}
                                        ref={ref}
                                        className={"form-select"}
                                        getPopupContainer={node => node.parentNode}
                                    >
                                        {devices.map(device => <Option value={device.id}>{device.model}</Option>)}
                                    </Select>)}
                                    rules={{required: REQUIRED_FIELD}}
                                />
                                {errors.deviceId && <span className="loggin-error"><img
                                    src={ErrorIcon}/> {errors.deviceId.message}</span>}
                            </div>
                        </div>

                        <div className={"row mb-2"}>
                            <div className={"col-12"}>
                                <label className="mb-2 form-label" htmlFor="command">Komanda</label>
                                <Controller
                                    control={control}
                                    name={"methodName"}
                                    render={({
                                                 field: {onChange, value, ref},
                                             }) => (<Select
                                        onChange={onChange}
                                        value={value}
                                        ref={ref}
                                        className={"form-select"}
                                        getPopupContainer={node => node.parentNode}
                                        showSearch
                                    >
                                        {commands.map(command => <Option
                                            value={command.value}>{command.label}</Option>)}
                                    </Select>)}
                                    rules={{required: REQUIRED_FIELD}}
                                />
                                {errors.methodName && <span className="loggin-error"><img
                                    src={ErrorIcon}/> {errors.methodName.message}</span>}
                            </div>

                        </div>
                        <div className={"row mb-4"}>
                            <div className={"col-12"}>
                                <label className="mb-2 form-label" htmlFor="args">Argumenti</label>
                                <input type={"text"} {...register("arguments")}
                                       className={"form-control"}/>
                                {errors.arguments && <span className="loggin-error"><img
                                    src={ErrorIcon}/> {errors.arguments.message}</span>}
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-12"}>
                                <div className={"modal-footer-component"}>
                                    <button className={"btn btn-modal-cancel"} onClick={onModalClose} type={"button"}>
                                        {"Otkaži"}
                                    </button>
                                    <button className={"btn btn-modal-confirm"}
                                            onClick={handleSubmit(onsubmit)}>Pošalji
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default CommandsModal;